import React from 'react';

import { ReactComponent as Refresh } from '../../../assets/images/Refresh.svg';
import { ReactComponent as Update } from '../../../assets/images/Update.svg';
import { resetSiteData } from '../../../auth/functions/resetSiteData';
import { t } from '../../../i18n';
import { KdModalType } from '../../../types/kdModal';
import KdButton from '../../KdButton';
import MessageModal from '../MessageModal';

type NotifierProps = KdModalType & {
  minVersion: number;
  currentVersion: number;
  onIgnore: () => void;
};

const VersionOutOfDateNotifier: React.FC<NotifierProps> = ({
  minVersion,
  currentVersion,
  onIgnore,
  show,
}) => {
  const refresh = () => {
    resetSiteData({});
  };

  const ignore = () => {
    if (onIgnore) {
      onIgnore();
    }
  };

  return (
    <MessageModal
      icon={<Update />}
      description={`${t('You are currently using Version')} ${currentVersion}.
      ${t(
        'Please click refresh to install the latest update and ensure that all features continue to work as expected'
      )}
      .`}
      show={show}
      title={`${t(
        'New Update Available For Kerb Delivery - Version'
      )} ${minVersion}`}
      actions={
        <>
          <KdButton
            type="button"
            onClick={ignore}
            className="button --warning"
          >
            {t('Ignore')}
          </KdButton>
          <KdButton
            type="button"
            onClick={refresh}
            className="button"
          >
            {t('Refresh')}&nbsp;
            <Refresh />
          </KdButton>
        </>
      }
    />
  );
};
export default VersionOutOfDateNotifier;
